<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col left" v-if="iScreen(['lg'])" >
                <settings-navigation></settings-navigation>
            </div>
            <div class="col content">
                <transition name="slide" mode="out-in">
                    <router-view></router-view>
                </transition>
            </div>
        </div>
    </div>
</template>

<script>
    import SettingsNavigation from '@/components/settings/settings-navigation';
    import {mixin} from '@/mixins/mixins';
    export default {
      mixins: [mixin],
      name: 'Settings',
    data () {
      return {
        msg: 'Settings Page'
      }
    },
    components: {
      SettingsNavigation
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/settings/settings.vue